import React from 'react';
import { ReadMoreLinkStyled } from './styled';

const ReadMoreLink = ({ Href, Rel, children }) => {
  return (
    <ReadMoreLinkStyled href={Href} rel={Rel}>
      {children}
    </ReadMoreLinkStyled>
  );
};

export default ReadMoreLink;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/ReadMoreLink/ReadMoreLink.js